import httpRequest from 'httpRequest'
import { PaymentAccountContract, PaymentAccountUpdateContract } from 'models'
import { AccountLedgerEntryDetailContract } from 'models/AccountLedgerEntryDetailContract'
import { AccountSummaryContract } from 'models/AccountSummaryContract'
import { CustomerPaymentAccountDetailContract } from 'models/CustomerPaymentAccountDetailContract'
import { PaymentAccountAdjustmentContract } from 'models/PaymentAccountAdjustmentContract'

const LOCATION_PAYMENT_ACCOUNT_PREFIX = '/location/payment-accounts'
const COMPANY_PAYMENT_ACCOUNT_PREFIX = '/company/payment-accounts'
export interface SearchPaymentAccountEntryRequest {
    startDate?: string
    endDate?: string
    startTime?: string
    endTime?: string
    paymentAccountID?: string
    customerID?: string
}
export interface SearchPaymentAccountRequest {
    locationIDs: string[]
}
const paymentAccountsService = {
    activatePaymentAccount: (id: string, isActive: boolean) => {
        return httpRequest.put(
            `${COMPANY_PAYMENT_ACCOUNT_PREFIX}/${id}/set-active`,
            JSON.stringify(isActive),
        )
    },
    createPaymentAccount: (payload: PaymentAccountUpdateContract) => {
        return httpRequest.post<PaymentAccountContract>(
            `${LOCATION_PAYMENT_ACCOUNT_PREFIX}`,
            payload,
        )
    },
    deletePaymentAccountByIDs: (ids: string[]) => {
        return httpRequest.delete(`${COMPANY_PAYMENT_ACCOUNT_PREFIX}`, {
            params: { paymentAccountIDs: ids },
        })
    },
    getPaymentAccountByID: (id: string) => {
        return httpRequest.get<PaymentAccountContract>(
            `${COMPANY_PAYMENT_ACCOUNT_PREFIX}/${id}`,
        )
    },
    getPaymentAccounts: (search?: SearchPaymentAccountRequest) => {
        return httpRequest.get<PaymentAccountContract[]>(
            `${COMPANY_PAYMENT_ACCOUNT_PREFIX}`,
            { params: search },
        )
    },
    updatePaymentAccount: (
        id: string,
        payload: PaymentAccountUpdateContract,
    ) => {
        return httpRequest.put(
            `${COMPANY_PAYMENT_ACCOUNT_PREFIX}/${id}`,
            payload,
        )
    },
    getPaymentAccountHistories: (payload: SearchPaymentAccountEntryRequest) => {
        return httpRequest.get<AccountLedgerEntryDetailContract[]>(
            `${COMPANY_PAYMENT_ACCOUNT_PREFIX}/history`,
            {
                params: payload,
            },
        )
    },
    getPaymentAccountSummary: (accountID: string) => {
        return httpRequest.get<AccountSummaryContract>(
            `${COMPANY_PAYMENT_ACCOUNT_PREFIX}/${accountID}/summary`,
        )
    },
    getCustomerPaymentAccounts: (customerID?: string) => {
        return httpRequest.get<CustomerPaymentAccountDetailContract[]>(
            `${LOCATION_PAYMENT_ACCOUNT_PREFIX}/customer-accounts`,
            {
                params: { customerID },
            },
        )
    },
    adjustPaymentAccount: (
        accountID: string,
        payload: PaymentAccountAdjustmentContract,
    ) => {
        return httpRequest.post(
            `${COMPANY_PAYMENT_ACCOUNT_PREFIX}/${accountID}/adjustment`,
            payload,
        )
    },
}

export default paymentAccountsService
